import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import Button from '../common/Button';
import { Link } from 'react-router-dom';
import imeettechLogo from '../../assets/images/channels.png'

const HeroContainer = styled.section`
  color: white;
  padding: 6rem 0;
  position: relative;
  overflow: hidden;
`;

const HeroContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 ${props => props.theme.spacing.md};
  position: relative;
  z-index: 2;

  @media (min-width: ${props => props.theme.breakpoints.tablet}) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 3rem;
    align-items: center;
  }
`;

const HeroText = styled.div`
  text-align: center;

  @media (min-width: ${props => props.theme.breakpoints.tablet}) {
    text-align: left;
  }
`;

const HeroTitle = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  line-height: 1.2;
  color: #1e212a;
`;

const HeroSubtitle = styled.h2`
  font-size: 1rem;
  font-weight: 400;
  margin-bottom: 2rem;
  opacity: 0.9;
  color: #333;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;

  @media (min-width: ${props => props.theme.breakpoints.tablet}) {
    justify-content: flex-start;
  }
`;

const HeroImage = styled.div`
  margin-top: 3rem;
  display: flex;
  justify-content: center;

  img {
    max-width: 100%;
    height: auto;
  }

  @media (min-width: ${props => props.theme.breakpoints.tablet}) {
    margin-top: 0;
  }
`;

const HeroSection = () => {
  const { t } = useTranslation();

  return (
    <HeroContainer>
      <HeroContent>
        <HeroText>
          <HeroTitle>An easy to use digital asset management & product information management system (DAM & PIM Software)</HeroTitle>
          <HeroSubtitle>Take your eCommerce operations to the next level with Catsy's
            intuitive Product Information Management (PIM) and Digital Asset Management (DAM) solution</HeroSubtitle>
          <ButtonGroup>
            <Link to="/products" className="bg-black rounded-md text-white hover:bg-gray-800 font-bold py-2 px-6 rounded transition-colors duration-200"> {t('solutions.title')} </Link>
            <Link to="/contact" className="bg-black text-white hover:bg-gray-800 font-bold py-2 px-6 rounded transition-colors duration-200"> {t('contact.title')} </Link>

            {/* <Link
              to="/products"
              className="bg-black text-white hover:bg-white hover:text-black border border-transparent hover:border-black font-bold py-2 px-4 rounded transition-all duration-200"
            >
              {t('solutions.title')}
            </Link> */}
          </ButtonGroup>
        </HeroText>
        <HeroImage>
          <img src={imeettechLogo} alt="IMEETTECH Global Solutions" />
        </HeroImage>
      </HeroContent>
    </HeroContainer>
  );
};

export default HeroSection;